module.exports = "<p>\r\n  main-footer works!\r\n</p>\r\n"